import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { CardListItem, CardListItemProps } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemStatusIcons } from 'record-it-components/cardList/CardListItemStatusIcons/CardListItemStatusIcons';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { IconDeprecated, IconSize } from 'record-it-components/misc/IconDeprecated/IconDeprecated';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useConstructionSiteDeleteHandler } from '../../../hooks/entity/deleteHandler/useConstructionSiteDeleteHandler';
import { EditConstructionSiteDialog } from '../EditConstructionSiteDialog/EditConstructionSiteDialog';
export type ConstructionSiteListItemProps = PropsWithoutChildren<CardListItemProps> & {
  constructionSite: ConstructionSite;
};
export const ConstructionSiteListItem: FunctionComponent<ConstructionSiteListItemProps> = React.memo(props => {
  const $ = _c(29);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let constructionSite;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      constructionSite,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = constructionSite;
    $[4] = remainingProps;
  } else {
    constructionSite = $[3];
    remainingProps = $[4];
  }
  const handleDeleteClick = useConstructionSiteDeleteHandler(constructionSite);
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      closeOnBackDropClick: true
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    open: openEditDialog,
    close: closeEditDialog,
    modalProps
  } = useModalOpened(t1);
  let t2;
  if ($[6] !== constructionSite.name) {
    t2 = <CardListItemTitle data-testid="ConstructionSiteListItem.Title">{constructionSite.name}</CardListItemTitle>;
    $[6] = constructionSite.name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== constructionSite.archived) {
    t3 = constructionSite.archived ? <IconDeprecated {...iconConfigurations.default.status.archived} size={IconSize.Small} data-testid="ConstructionSiteListItem.ArchivedStatusIcon" /> : null;
    $[8] = constructionSite.archived;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <CardListItemStatusIcons>{t3}</CardListItemStatusIcons>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== handleDeleteClick) {
    t5 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.deleteIcon} onClick={handleDeleteClick} data-testid="ConstructionSiteListItem.DeleteButton" />;
    $[12] = handleDeleteClick;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== openEditDialog) {
    t6 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.editInDialogIcon} onClick={openEditDialog} data-testid="ConstructionSiteListItem.EditButton" />;
    $[14] = openEditDialog;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== remainingProps || $[17] !== t2 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <CardListItem {...remainingProps}>{t2}{t4}{t5}{t6}</CardListItem>;
    $[16] = remainingProps;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== closeEditDialog || $[23] !== constructionSite || $[24] !== modalProps) {
    t8 = <EditConstructionSiteDialog constructionSite={constructionSite} onAccept={closeEditDialog} {...modalProps} data-testid="ConstructionSiteListItem.EditDialog" />;
    $[22] = closeEditDialog;
    $[23] = constructionSite;
    $[24] = modalProps;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t7 || $[27] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
});